import Skeleton from '../../../app/components/Skeleton'

import styles from './DeliveryLocationConfigureModalSkeleton.module.scss'

export default function DeliveryLocationConfigureModalSkeleton() {
  return (
    <>
      <Skeleton className={styles.searchInput} />
      <Skeleton className={styles.mapContainer} />
      <Skeleton className={styles.deliveryInstructions} />
      <Skeleton className={styles.submitButton} />
    </>
  )
}
